import { apiClient } from "@/api/api-client";
import type { ProjectCategoryAttachmentInfo } from "@/types/project-category-attachment";

export interface Option {
	value: string;
	label: string;
}

interface EnumsResponse {
	project_category_attachments: ProjectCategoryAttachmentInfo[];
	unit_types: Option[];
	period_types: Option[];
	markluo_rates: Option[];
}

const enumService = {
	/**
	 * Get all available enums
	 */
	async getAll(): Promise<EnumsResponse> {
		const response = await apiClient.get<EnumsResponse>("/enums");
		return response.data;
	},

	/**
	 * Get all project category attachments
	 */
	async getProjectCategoryAttachments(): Promise<ProjectCategoryAttachmentInfo[]> {
		const response = await apiClient.get<ProjectCategoryAttachmentInfo[]>("/enums/project-category-attachments");
		return response.data;
	},

	/**
	 * Get government project attachments
	 */
	async getGovernmentProjectAttachments(): Promise<ProjectCategoryAttachmentInfo[]> {
		const response = await apiClient.get<ProjectCategoryAttachmentInfo[]>("/enums/project-category-attachments/government");
		return response.data;
	},

	/**
	 * Get private project attachments
	 */
	async getPrivateProjectAttachments(): Promise<ProjectCategoryAttachmentInfo[]> {
		const response = await apiClient.get<ProjectCategoryAttachmentInfo[]>("/enums/project-category-attachments/private");
		return response.data;
	},

	/**
	 * Get unit types
	 */
	async getUnitTypes(): Promise<Option[]> {
		const response = await apiClient.get<Option[]>("/enums/unit-types"); // connects to api
		return response.data;
	},

	/**
	 * Get period types
	 */
	async getPeriodTypes(): Promise<Option[]> {
		const response = await apiClient.get<Option[]>("/enums/period-types");
		return response.data
	},

	/**
	 * Get period types
	 */
	async getMarkupRates(): Promise<Option[]> {
		const response = await apiClient.get<Option[]>("/enums/markup-rates");
		return response.data
	},
};

export default enumService;
